import typography from './typography.module.scss';
import colors from './colors.module.scss';

export default {
  ...typography,
  colors,
};
